const path = require('path')
const jenkins = require('jenkins')
const SshClient = require('ssh2').Client
const moment = require('moment')
const axios = require('axios')
const chalk = require('chalk')
const sh = require('shelljs')
const { NotificationCenter } = require('node-notifier')
const notificationCenter = new NotificationCenter()

const { 
    begin, 
    finish, 
    accent,
    warn,
    error, 
    newline, 
    config,
    inquirer,
    spinner,
    report,
    reportSuccess,
    CLI_ROOT,
} = require('../../common.js')

// TEMP - as soon as certs are set up in ops, this can go.
process.env.NODE_TLS_REJECT_UNAUTHORIZED = 0

const pollInterval = 1000
const localData = {}
const networkToUrl = {
    "sbx": "http://sbxops.sbx.avtr.net",
    "gnz": "http://ops.avtr.net",
}

module.exports = (yargs) => {
    const argv = yargs
		.reset()
        .argv
    
    const network = argv._[1]
    if (network)
        localData.network = network
        
    const stack = argv._[2]
    if (stack)
        localData.stack = stack
        
    const name = config.get('name')
    localData.username = name.first.toLowerCase().slice(0, 1) + name.last.toLowerCase()

    begin("build")
        .then(_inquirePassword)
        .then(_validatePassword)
        .then(_inquireNetwork)
        .then(_getNetworkStackStatuses)
        .then(_inquireStack)
        .then(_syncBranch)
        .then(_setJenkinsConfiguration)
        .then(_runJenkinsBuild)
        .then(_inquireShouldDeploy)
        .then(_updateDashboardOnServer)
        .then(_notifySuccess)
        .then(_cleanUpPassword)
        .then(_finish)
        .catch(err => {
            error("build", "could not build, caused by:\n" + err)
        })

}

function _finish() {
    _cleanUpPassword()
    spinner.stop()
    finish()
}

function _inquirePassword() {
    return inquirer
        .prompt([{
            type: 'password',
            name: 'password',
            message: `password for ${localData.username}:`,
            mask: '*',
        }])
        .then(({ password }) => {
            newline()
            localData.password = password
        })
}

function _validatePassword() {
    const url = networkToUrl["sbx"] + '/services/security/config'
    return axios.get(url, {
        auth: {
            username: localData.username,
            password: localData.password,
          },
    })
        .catch(() => {
            throw new Error("incorrect password")
        })
}

function _inquireNetwork() {
    if (localData.network) return Promise.resolve()
    return inquirer
        .prompt([
            {
                type: 'list',
                choices: ['sbx', 'gnz'],
                message: 'network:',
                name: 'network',
            },
        ])
        .then(({ network }) => {
            localData.network = network
        })
}

function _inquireStack() {
    if (localData.stack) return Promise.resolve()
    return inquirer
        .prompt([
            {
                type: 'list',
                choices: [
                    `active (${localData.aIsActiveStack ? "a" : "b"})`, 
                    `inactive (${localData.aIsActiveStack ? "b" : "a"})`,
                ],
                message: 'stack:',
                name: 'stack',
            },
        ])
        .then(({ stack }) => {
            localData.stack = stack.split(' ')[0]
        })
}

function _getNetworkStackStatuses() {

    const url = networkToUrl[localData.network] + '/services/security/config'
    return axios.get(url, {
        auth: {
            username: localData.username,
            password: localData.password,
          },
    })
        .then(res => {
            localData.aIsActiveStack = res.data.data[0].opsStack === '/a'
        })

}

function _cleanUpPassword() {
    delete localData.password
    return Promise.resolve()
}

function _setJenkinsConfiguration() {
    // TO DO 
}

function _runJenkinsBuild() {

    const jenkinsClient = jenkins({
        baseUrl: `http://${localData.username}:${localData.password}@sbxops.sbx.avtr.net/jenkins`,
        crumbIssuer: true,
        promisify: true,
    })

    report('starting jenkins build')
    spinner.start()

    const pollForBuildNumber = (resolve, reject) => {

        localData.pollForBuildNumberAttempts++

        if (localData.pollForBuildNumberAttempts === 2)
        {
            spinner.stop()
            report('waiting for executor...')
            spinner.start()
        }

        jenkinsClient
            .queue
            .item(localData.queueNumber)
            .then(data => {
                if (data && data.executable && data.executable.number)
                    resolve(data.executable.number)
                else
                    setTimeout(
                        pollForBuildNumber, 
                        pollInterval, 
                        resolve, 
                        reject
                    )
            })
    }

    // TO DO - handle build stopped remotely
    const pollForBuildComplete = (resolve, reject) => {
        localData.pollForBuildCompleteAttempts++

        jenkinsClient
            .build
            .get('LEI Dashboard', localData.buildNumber)
            .then(data => {
                if (localData.estimatedBuildDuration !== data.estimatedDuration)
                {
                    localData.estimatedBuildDuration = data.estimatedDuration
                    spinner.stop()
                    report(chalk.gray(`build will take ~${moment.duration(
                        localData.estimatedBuildDuration, 'milliseconds'
                    ).humanize()}`))
                    spinner.start()
                }

                if (data.result === 'SUCCESS')
                    resolve(data)
                else if (data.result === 'FAILURE')
                    reject(new Error('jenkins build failed'))
                else
                    setTimeout(
                        pollForBuildComplete, 
                        pollInterval, 
                        resolve, 
                        reject
                    )
            })
    }

    return jenkinsClient.job.build({
        name: "LEI Dashboard", 
        parameters: {
            DASHBOARD_JENKINS_GIT_JAVASCRIPT_BRANCH: localData.branchName,
            DASHBOARD_JENKINS_NETWORK: localData.network,
        }, 
    })
        .then(queueNumber => {
            localData.queueNumber = queueNumber
            localData.pollForBuildNumberAttempts = 0
            return new Promise(pollForBuildNumber)
        })
        .then(buildNumber => {

            localData.buildNumber = buildNumber

            spinner.stop()
            report(`building (#${localData.buildNumber})`)
            spinner.start()

            localData.pollForBuildCompleteAttempts = 0
            return new Promise(pollForBuildComplete)
            
        })
        .then((data) => {

            // DEV - the data does include a duration property, but it's super unreliable, keeps coming back as 0

            spinner.stop()
            reportSuccess('build finished')
        })
    
}


function _inquireShouldDeploy() {

    const trueAnswer = 'Deploy'

    return new Promise((resolve, reject) => {
        
        inquirer.prompt([{
            type: "confirm",
            name: 'shouldDeploy',
            message: `deploy to ${localData.network} ${localData.stack}?`
        }])
            .then(({ shouldDeploy }) => {
                resolve(shouldDeploy)
            })

        notificationCenter.notify({
            title: "ops build --",
            message: `Jenkins build finished. Deploy to ${localData.network} ${localData.stack}?`,
            sound: "Pop",
            closeLabel: 'Cancel',
            actions: trueAnswer,
        },
        (error, response, data={}) => {
            if (error)
                return reject(error)

            if (data.activationType !== 'timeout')
                return resolve(data.activationValue === trueAnswer)

        })
    })
        .then(shouldDeploy => {
            if (!shouldDeploy)
            {
                report(chalk.yellow('deploy aborted'))
                _finish()
            }
        })
}

// TO DO - multiple commands might want to use this, maybe move out
function _syncBranch() {

    const branchName = sh.exec(
        'git symbolic-ref --quiet --short HEAD',
		{ silent: true }
    ).stdout.trim()

    // TO DO - move the execution to the js repo
    if (!branchName)
        throw new Error('git branch not found in execution context')
    
    localData.branchName = branchName
    report('committing local changes to branch ' + accent(branchName))

	sh.exec('git add -A', { silent: true })
    sh.exec(`git commit -m "sync before build"`, { silent: true })

    report('pulling from remote')
    
    const pullResult = sh.exec(
        `git pull origin ${branchName}`, 
        { silent: true }
    )
    
    report(chalk.gray('> ' + pullResult.stdout.trim()))
    // TO DO - handle conflicts

	// Deal with conflicts, list files with conflicts,
	// offer option to open in text editor
	// if yes automatically do the following:
	// offer to wait until conflicts are fixed
	// offer "conflicts fixed" and "cancel" buttons

    report('pushing to remote')

    sh.exec(`git push origin ${branchName}`, { silent: true })
    
    reportSuccess('sync complete')

    return Promise.resolve()

}

function _updateDashboardOnServer() {

    newline()    

    const ping = () => axios.get(
        `${networkToUrl[localData.network]}${localData.stack === "active" ? "" : ":8080"}/services/dashboard/version`,
        {
            auth: {
                username: localData.username,
                password: localData.password,
            },
        }
    )

    
    const pollForDashboardDropOut = (resolve, reject) => {
        const pollLimit = 15

        localData.pollForDashboardDropOutAttempts++

        if (localData.pollForDashboardDropOutAttempts === pollLimit)
            return resolve()
        
        ping()
            .then(() => {
                setTimeout(
                    pollForDashboardDropOut, 
                    pollInterval, 
                    resolve, 
                    reject
                )
            })
            .catch(() => {
                resolve()
            })
            
    }

    const pollForDashboardDropIn = (resolve, reject) => {
        const pollLimit = 5 * 60

        localData.pollForDashboardDropInAttempts++

        if (localData.pollForDashboardDropInAttempts === pollLimit)
            return reject(
                new Error("Dashboard hasn't come back after update, something may be wrong on the server.")
            )

        ping()
            .then((data) => {
                resolve()
            })
            .catch((data) => {
                setTimeout(
                    pollForDashboardDropIn, 
                    pollInterval, 
                    resolve, 
                    reject
                )
            })
    }

    const deployScriptDirectory = "/usr/share/wildfly/standalone/deployments"

    const stack = localData.stack === "active" ?
        localData.aIsActiveStack ? "a" : "b" :
        localData.aIsActiveStack ? "b" : "a"
    const host = localData.network === 'sbx' ?
        `sbxwebservices${stack}.sbx.avtr.net` :
        `webservices${stack}.avtr.net`


    report(`connecting to ${host}`)

    const connection = new SshClient()

    return new Promise((resolve, reject) => {        
        connection
            .on('ready', () => {

                report("updating services")

                connection.exec(
                    `cd ${deployScriptDirectory} && ./UpdateDashboard.sh ${localData.branchName} ${localData.network}`, 
                    { pty: true }, 
                    (error, stream) => {
                        if (error)
                            throw error
                        
                        stream
                            .on('close', connection.end)
                            .on('data', function(data) {
                                if (
                                    data.includes(`[sudo] password for ${localData.username}:`) ||
                                    data.includes(`Password:`)
                                )
                                    stream.write(localData.password + '\n')

                                if (data.includes("Services updated"))
                                    connection.end()
                            })
                            .stderr.on('data', (data) => {
                                reject(new Error("Remote Error: " + data))
                                connection.end()
                            })

                    }
                )

            })
            .on('end', resolve)
            .on('error', reject)
            .connect({
                host,
                username: localData.username,
                password: localData.password,
                tryKeyboard: true,
            })
  
    })
        .then(() => {
            report("restarting wildfly")
            localData.pollForDashboardDropOutAttempts = 0
            return new Promise(pollForDashboardDropOut)
        })
        .then(() => {
            localData.pollForDashboardDropInAttempts = 0
            return new Promise(pollForDashboardDropIn)
        })
        .then(() => {
            reportSuccess("update complete")
        })

}

function _notifySuccess() {
    // TO DO - add an "announce" button to the notification which will post a notification to slack
    notificationCenter.notify({
        title: "ops build --",
        message: `Success. Click to open ${localData.network} ${localData.stack}.`,
        sound: "Pop",
        wait: true,
        open: `${networkToUrl[localData.network]}${localData.stack === "active" ? "" : ":8080"}`,
    })

    return Promise.resolve()
}


// WEBPACK FOOTER //
// ./src/commands/build/index.js